import React from 'react';

import AwsConfig from '../awsConfig';
import BobNavigation from './BobNavigation';
import BobNavSelectors from './BobNavSelectors';
import BobContextMenu from './BobContextMenu';
import BobConfiguration from './BobConfiguration';
import Button from '@material-ui/core/Button';
import classes from './BobHeader.module.css';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

const BobHeader = ({
    targetNavCompany,
    history,
    ...props
}) => {

    const onClickHandle = () => {
        window.open(AwsConfig.key2act.helpUrl, '_blank');
    };

    const handleJobs = () => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);
        history.push({
            pathname: '/v2/dashboard/processes',
            search:   queryValuesString,
            state:    { 'returnUrl': `${pathname}` }
        });
    };

    return (
        <header className={classes.Header}>
            <div className={classes.Header_Logo}>
                <img src="/assets/images/WennSoft Icon.png" alt="WennSoft Inc." />
            </div>
            <BobNavigation {...props} />
            <BobNavSelectors isFromHeader={true} />
            <div className={classes.Header_Controls_with_eye_Icon}>
                <div className={classes.Header_Controls_Help}>
                    <Button
                        className={classes.Header_Help_Button}
                        onClick={handleJobs}
                    >
                        <i className={`fas fa-running ${classes.Header_Running_Icon}`} aria-hidden="true" />
                    </Button>
                    <Button
                        className={classes.Header_Help_Button}
                        onClick={onClickHandle}
                    >
                        <i className="fas fa-question" aria-hidden="true" />
                    </Button>
                </div>
                <div className={classes.Header_Controls_Menu}>
                    {
                        process.env.saveViewAndConfigurationEnabled ?
                            <div className={classes.Header_Eye_Icon}>
                                <BobConfiguration />
                            </div> : null
                    }
                    <BobContextMenu {...props} />
                </div>
            </div>
        </header>
    );
};

const mapStateToProps = state => ({
    targetNavCompany: state.bob.targetNavCompany
});

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobHeader));

